import { NgModule } from '@angular/core';
import { AuthenticatedUserService } from './authenticatedUser.service';
import { OrganizationModel } from './models/organization.model';

@NgModule({
    providers: [AuthenticatedUserService, OrganizationModel]
})
export class AuthenticatedUserModule {}
